module.exports = __webpack_public_path__ + "img/map-pin.db532787.svg";